export default "__VITE_ASSET__BaSyuf$Z__"